import React from "react";
import PropTypes from 'prop-types';

import style from "./InfoCard.css";

const InfoCard = ({ image, title, body, height = "100%", width = "100%", titleOffset = false }) => {
  let titleWidth;

  if (titleOffset) {
    titleWidth = (title.length * 10) + "px";
  }

  return (
    <div className={style.infoCard}>
      <div className={style.infoImg} style={{height: height, width: width}}>
        <img className={style.img} src={image}/>
      </div>
      <div className={style.info}>
        <h4
          style={{ width: titleWidth }}
          className={style.title}>
          {title}
        </h4>
        <div className={style.body}
            dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  );
};

InfoCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  titleOffset: PropTypes.bool
};

export default InfoCard;



// WEBPACK FOOTER //
// ./component/InfoCard/index.js